var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"dense":"","outlined":"","hide-details":"","value":_vm.value,"items":_vm.itemsTrans,"item-text":"name","item-value":"value","label":_vm.$t('label.select-voucher-type')},on:{"input":function($event){return _vm.$emit('input',$event)},"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }